import React, {useContext} from "react";
import PropTypes from "prop-types";
import {FormattedMessage, injectIntl} from "react-intl";
import {connect} from "react-redux";

import {getEnglishLeadType, getLeadTypes, getStatuses, toggleJobBoardFilterSimpleValue} from "../../../utilities/job";
import Select4 from "../../Generic/Select4";
import JobBoardFiltersContext from "./JobBoardFiltersContext";

const JobBoardFiltersPopupSimpleFilter = (props) => {

  const {filterName, filterKeyIntl} = props;
  const [popupFilters, setPopupFilters] = useContext(JobBoardFiltersContext);

  const getSelectItems = () => {
    switch (filterName) {
      case "leadType":
        return ["jobBoard.leadType.All", ...getLeadTypes()].map((intlKey) => {
          return {text: intlKey, value: getEnglishLeadType(intlKey)}
        })
      case "status":
        return ["jobBoard.leadType.All", ...getStatuses()].map((intlKey) => {
          return {text: intlKey, value: getEnglishLeadType(intlKey)}
        })
    }
  }

  const selectItemClick = (selectItem) => {
    setPopupFilters(
      [...toggleJobBoardFilterSimpleValue(popupFilters, {name: filterName, value: selectItem.value}, true)]
      // here we use true because we want to replace value, not remove it (select issue)
    )
  }

  const selectItems = getSelectItems();

  const filterSelected = popupFilters.find(filter => filter.name === filterName);
  const selected = (filterSelected && selectItems.find(selectItem => selectItem.value === filterSelected.value))
    || {text: "select.defaultValue", value: "Select"};

  return (
    <div className="jb-filters__block">
      <div className="generic-popup-title"><FormattedMessage id={filterKeyIntl}/></div>
      <Select4 selectItemClick={selectItemClick}
               selectItems={selectItems}
               maxItems={selectItems.length > 7 ? 7 : 0}
               className={"select4--blue"}
               selectedItem={selected}/>
    </div>
  )
};

JobBoardFiltersPopupSimpleFilter.propTypes = {
  filterName: PropTypes.string.isRequired,
  filterKeyIntl: PropTypes.string.isRequired,
};

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = {};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(JobBoardFiltersPopupSimpleFilter)
)
